import React from "react";
import Header from "../common/Header";
import ChatavirsityData from "./ChatavirsityData";

const MyChatavirsity = () => {
  return (
    <>
      <div className="bg-light_purple7 rounded-2xl overflow-x-hidden  h-[calc(100vh-32px)]">
        <div className="px-5 relative  overflow-hidden pb-3">
          <div className=" overflow-hidden">
            <Header text="Chatavirsity" />
          </div>
          <div className="w-full">
            <ChatavirsityData />
          </div>
        </div>
      </div>
    </>
  );
};

export default MyChatavirsity;
